import React from "react";
import ArrowRight from "../ArrowRight";
import ArrowLeft from "../ArrowLeft";

const MintFooter = ({
  nextHover,
  nextButton,
  backButton,
  stepTotal,
  stepState,
  validateSelection,
  ReturnToArtPack,
  ReturnToCampaign,
  Previous,
  Continue,
  MintNft,
  restart,
  color,
  campaign
}) => {

  const returnToArtPack = () => {
    // Show "Return to Art Pack" only when:
    // 1. We're on the first step (stepState === 0)
    // 2. The preview source is from artist (not from sponsor campaign creation)
    const previewSource = sessionStorage.getItem('previewSource');
    if(stepState === 0 && previewSource === 'artist') {
      return (
        <button
          className="mint__btn no-border mint__btn-prev"
          style={{color: color}}
          onClick={ReturnToArtPack}
        >
          <div className="arrow-group left">
            <ArrowLeft color={color ? color : "#58585D"} />
            Return to Art Pack
          </div>
        </button>
      );
    }
  }

  const returnToCampaign = () => {
    // Show "Return to Campaign" only when:
    // 1. We're on the first step (stepState === 0)
    // 2. The preview source is from sponsor and context is campaign-form
    const previewSource = sessionStorage.getItem('previewSource');
    const previewContext = sessionStorage.getItem('previewContext');
    if(stepState === 0 && previewSource === 'sponsor' && previewContext === 'campaign-form') {
      return (
        <button
          className="mint__btn no-border mint__btn-prev"
          style={{color: color}}
          onClick={ReturnToCampaign}
        >
          <div className="arrow-group left">
            <ArrowLeft color={color ? color : "#58585D"} />
            Return to Campaign
          </div>
        </button>
      );
    }
  }
  const showPrevious = () => {
    if (stepState) {
      return (
        <button
          className="mint__btn no-border mint__btn-prev"
          style={{color: color}}
          onClick={Previous}
        >
          <div className="arrow-group left">
            <ArrowLeft color={color ? color : "#58585D"} />
            {backButton}
          </div>
        </button>
      );
    }
  };

  const showNext = () => {
    if (stepState < stepTotal) {
      return (
        <>
          <button
            className="mint__btn no-border mint__btn-next"
            onClick={Continue}
            disabled={!validateSelection() ? true : false}
            style={{color: !validateSelection() ? "#cbcbcb" : color}}
          >
            {!validateSelection() ? (
              <span
                className="tooltiptext"
                style={{ width: "140px", top: "unset" }}
              >
                {nextHover}
              </span>
            ) : (
              <></>
            )}
            <div className="arrow-group right" >
              {nextButton}
              {!validateSelection() ? (
                <ArrowRight color="#cbcbcb" />
              ) : (
                <ArrowRight color={color ? color : "#58585D"} />
              )}
            </div>
          </button>
        </>
      );
    }
  };

  const showMint = () => {
    if (stepState === stepTotal && campaign?.campaign_id) {
      return (
        <div className="mint__btn no-border mint__btn-next" onClick={MintNft} style={{color: color}}>
          <span>Use as Sample!</span>
        </div>
      );
    }
    else if(stepState === stepTotal && !campaign?.campaign_id) {
      return (
        <div className="mint__btn no-border mint__btn-next" onClick={restart} style={{color: color}}>
          <span>Restart</span>
        </div>
      );
    }
  };
  return (
    <div className="mint_btn_wrapper">
      {returnToArtPack()}
      {returnToCampaign()}
      {showPrevious()}
      {showNext()}
      {showMint()}
    </div>
  );
};

export default React.memo(MintFooter);
